(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup-coupons"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-popup-target]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const popupId = link.getAttribute('data-popup-target');
      const popup = document.getElementById(popupId);
      popup.style.display = 'flex';

      const coupon = link.closest('.popup-coupon');
      const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      if (isTouch) {
        coupon.classList.add('hovering');
        setTimeout(() => {
          coupon.classList.add('active');
          coupon.classList.remove('hovering');
        }, 300);
      } else {
        coupon.classList.add('active');
      }
    });
  });

  document.querySelectorAll('.popup-close').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      closePopup(closeBtn.closest('.popup-overlay'));
    });
  });

  document.querySelectorAll('.popup-overlay').forEach(overlay => {
    overlay.addEventListener('click', e => {
      if (e.target === overlay) {
        closePopup(overlay);
      }
    });
  });

  function closePopup(popup) {
    popup.style.display = 'none';
    const coupon = document.querySelector('.popup-coupon.active');
    if (coupon) {
      coupon.classList.remove('active');
      coupon.classList.add('returning');
      setTimeout(() => {
        coupon.classList.remove('returning');
      }, 300);
    }
  }

  document.querySelectorAll('.copy-code-button').forEach((button) => {
    const originalText = button.textContent;

    button.addEventListener('click', async () => {
      // prevent re-click spam
      if (button.classList.contains('is-copied')) return;

      const codeId = button.getAttribute('data-code-id');
      const input = document.getElementById(codeId);
      if (!input) return;

      try {
        await navigator.clipboard.writeText(input.value);

        // keep popup open, just update button UI
        button.textContent = 'Copied';
        button.classList.add('is-copied');

        // optional: revert after 2 seconds (remove if you want it to stay "Copied")
        setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove('is-copied');
        }, 2000);
      } catch (err) {
        // optional fallback message if clipboard fails
        button.textContent = 'Failed';
        setTimeout(() => {
          button.textContent = originalText;
        }, 1500);
      }
    });
  });


  } catch(e) { console.error(e); }
})();
})();
